import styled from 'styled-components';

export const TextHeaderGroup = styled.div`
font-family: Merriweather, serif;font-weight: 300;padding: 30px 0px;
`